import React from "react";
import ServicesDesktopView from "../desktopServices";
import { useMediaQuery, useTheme } from "@mui/material";
import DentingServiceOverview from "./overview";
import BlogCarousel from "../common/Blogs";
import FAQ from "../common/Faq";
import ServiceList from "./servicesList";
import SeoInfo from "../../../SeoInfo";

const standardservices1 = [
  "HASSLE-FREE PICK/DROP",
  "COMPLETE DIAGNOSE AND SCANNING",
  "ENGINE OIL CHANGE",
  "OIL FILTER CHANGE",
  "AIR FILTER CHANGE",
  "AC CABIN FILTER CLEAN",
  "DIESEL/FUEL FILTER CLEAN",
  "COOLANT TOP UP",
  "BATTERY WATER TOP-UP",
  "WIPER FLUID TOP-UP",
  "BRAKE/CLUTCH FLUID TOP-UP",
  "FRONT & REAR BRAKES SERVICE",
  "SPARK PLUGS SERVICE",
  "SUSPENSION CHECK-UP",
  "INTERIOR VACUUM",
  "THROTTLE BODY WASH",
  "FREE VEHICLE DROP",
];

const periodicservices1 = [
  "HASSLE-FREE PICK/DROP",
  "COMPLETE DIAGNOSIS AND SCANNING",
  "ENGINE OIL CHANGE",
  "OIL FILTER CHANGE",
  "AIR FILTER CHANGE",
  "AC FILTER CHANGE",
  "DIESEL/FILTER CHANGE",
  "COOLANT TOP UP",
  "BATTERY TOP-UP",
  "WIPER FLUID TOP-UP",
  "BRAKE/CLUTCH FLUID TOP-UP",
  "GEAR/TRANSMISSION OIL TOP UP",
  "FRONT& REAR BRAKE PAD SERVICE",
  "SPARK PLUGS SERVICE",
  "SUSPENSION CHECK-UP",
  "RADIATOR AIR WAND",
  "WHEEL ALIGNMENT AND BALANCING",
  "TIRE ROTATION",
  "INTERIOR VACUUM",
  "THROTTLE BODY WASH",
];

const faqs = [
  {
    question:
      "Can Go Clutch perfectly match the original paint color of my car",
    answer:
      "Yes, Go Clutch has skilled technicians who use advanced color matching techniques to ensure a flawless finish. They have access to a wide range of automotive paints to achieve an exact match with your car's original color.",
  },
  {
    question:
      "How long does the denting and painting process typically take at Go Clutch?",
    answer:
      "The duration of the process can vary depending on the extent of the damage. However, Go Clutch strives to complete the work efficiently. You can consult with their team to get an accurate estimate for your specific case.",
  },
  {
    question: "Are Go Clutch's painters experts in their field?",
    answer:
      "Absolutely! Go Clutch employs highly skilled and experienced painters who are experts in their craft. They stay updated with the latest techniques and technologies to deliver top-notch results.",
  },
  {
    question:
      "What kind of warranty does Go Clutch offer on their denting and painting services?",
    answer:
      "Go Clutch offers a warranty on their denting and painting services. The specific terms of the warranty may vary, so it's best to inquire with their team for detailed information.",
  },
  {
    question: "Can Go Clutch handle complex denting and painting jobs?",
    answer:
      "Yes, Go Clutch has the expertise to handle complex denting and painting jobs. Whether it's a minor scratch or a major collision, their team is equipped to restore your car to its original condition.",
  },
];

const blogsData = [
  {
    id: 1,
    title: "How to Maintain Your Car?",
    description: "Best practices for car maintenance.",
    link: "https://goclutch.in/car-service-in-gachibowli/",
    image: "https://i.ibb.co/qk6VGfs/Blog-1.png",
  },
  {
    id: 2,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-services-in-hyderabad-2/",
    image: "https://i.ibb.co/7jDbjbg/blog-2.png",
  },
  {
    id: 3,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-service-in-hyderabad/",
    image: "https://i.ibb.co/pJ3RN2n/Blog-3.png",
  },
  {
    id: 4,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-services-in-kukatpally/",
    image: "https://i.ibb.co/xGRJHQz/blog-4.png",
  },
];

const DentingService = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <SeoInfo
        title="Premium Car Denting & Painting – Restore the Shine | Go Clutch"
        description="Go Clutch offers expert car denting & painting to remove scratches & restore your car’s shine. Precision work, perfect finish—book your service today!"
      />
      <DentingServiceOverview />
      <ServiceList />
      <BlogCarousel blogsData={blogsData} />
      <FAQ faqs={faqs} />
    </>
  );
};

export default DentingService;
